import authService from '../../services/AuthService'
import utilsService from '../../services/UtilsService'
import http from '../../http'

export const mutationsTypes = {
    LOGIN: 'auth/LOGIN',
    LOGOUT: 'auth/LOGOUT',
    MENU_MAIN_ACTIVE: 'auth/MENU_MAIN_ACTIVE',
    MENU_MAIN: 'auth/MENU_MAIN',
    SHOW_BUSINESS_LINE: 'auth/SHOW_BUSINESS_LINE',
    SHOW_CONTRACTS: 'auth/SHOW_CONTRACTS',
    CHANGE_PASSWORD_EXPIRED: 'auth/CHANGE_PASSWORD_EXPIRED'
};

const state = {
    user: {},
    logged: false,
    menus: {
        main: [
            {
                menuItem: 'exampleItem',
                active: false,
                role: 'ROLE_EXAMPLE'
            }
        ]
    }
};

/* eslint-disable no-param-reassign */
const mutations = {
    [mutationsTypes.LOGIN](state, payload) {
        state.user = payload;
        state.logged = true
    },

    [mutationsTypes.USER_DATA](state, payload) {
        state.user.name = payload.name;
    },

    [mutationsTypes.LOGOUT](state) {
        state.user = '';
        state.logged = false
    },

    [mutationsTypes.MENU_MAIN_ACTIVE](state, payload) {
        state.menus.main[payload.index].active = payload.active
    },

    [mutationsTypes.MENU_MAIN](state, payload) {
        state.menus.main = payload
    },

    [mutationsTypes.CHANGE_PASSWORD_EXPIRED](state, payload) {
        state.user.passwordExpired = payload.passwordExpired;
    }
};

const actions = {

    login: ({dispatch}, payload) => {

        return authService.login(
            payload.username,
            payload.password)
            .then(user => {

                let newUser = {};

                newUser.access_token = user.access_token;
                newUser.businessLines = user.businessLines;
                newUser.name = user.name;
                newUser.phone = user.phone;
                newUser.roles = user.roles;
                newUser.username = user.username;

                // Object.assign({}, user);

                utilsService.localStorageSetItem(mutationsTypes.LOGIN, newUser);
                dispatch('buildUser', newUser);
                return newUser;
            });
    },

    logout: ({commit}) => {
        utilsService.localStorageSetItem(mutationsTypes.LOGIN, '')
        commit(mutationsTypes.LOGOUT)
        http.defaults.headers.common['Authorization'] = ''
    },

    refreshAuthUser: ({dispatch}) => {

        let userFromLocalStorage = utilsService.localStorageGetItem(mutationsTypes.LOGIN);

        if (!state.logged && userFromLocalStorage && userFromLocalStorage !== '') {
            dispatch('buildUser', userFromLocalStorage)
        }
    },

    buildMenuMain({commit, dispatch, state}) {

        for (let i = 0; i < state.menus.main.length; i++) {
            dispatch('userHasRole', state.menus.main[i].role)
                .then(response => {
                    commit(mutationsTypes.MENU_MAIN_ACTIVE, {index: i, active: response})
                })
        }
    },

    userHasRole({}, payload) {

        /*if (payload) {

          let roles = state.user.roles;

          let authority = payload.substring(payload.length - 7, payload.length);
          authority = 'ROLE_' + authority;

          if (roles) {
            if (roles.indexOf(authority) >= 0) {
              return true
            }
          }
        }
        return false*/

        return utilsService.hasRole(state.user.roles, payload)
    },

    buildUser({commit, dispatch}, user) {

        commit(mutationsTypes.LOGIN, user);
        http.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
        dispatch('buildMenuMain');
    },

    updatePasswordExpired({commit}, payload) {
        commit(mutationsTypes.CHANGE_PASSWORD_EXPIRED, payload);
    },

    changePassword: ({}, payload) => {
        return authService.changePassword(payload);
    },

    retrievePassword: ({}, payload) => {
        return authService.retrievePassword(payload);
    },

    changePasswordByToken: ({}, payload) => {
        return authService.changePasswordByToken(payload);
    },

    changeUserContractVersion: ({dispatch}, payload) => {

        let userWithNewContractVersion = Object.assign({}, state.user);

        let businessAreaIndex = _.findIndex(
            userWithNewContractVersion.businessLines,
            {'id': payload.businessAreaId}
        );
        let contractIndex = _.findIndex(
            userWithNewContractVersion.businessLines[businessAreaIndex].contracts,
            {'id': payload.contractId}
        );

        userWithNewContractVersion.businessLines[businessAreaIndex].contracts[contractIndex].version = payload.version;

        utilsService.localStorageSetItem(mutationsTypes.LOGIN, userWithNewContractVersion);
        dispatch('buildUser', userWithNewContractVersion);
    }
};

const getters = {

    isLogged: () => {
        return state.logged
    },

    passwordExpired: () => {
        if (state.user.passwordExpired !== null) {
            return state.user.passwordExpired;
        }
        return false;
    },

    loggedUser: function (state) {
        return state.logged ? state.user : {}
    },

    authMenuMainExample: function () {
        return findItemMenuMain(state.menus.main, 'exampleItem').active
    },

    userLoggedRoles: function () {
        return state.logged ? state.user.roles : null
    }
};

const findItemMenuMain = function (list, itemFind) {
    return list.filter((item) => {
        return item.menuItem == itemFind;
    })[0]
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/app/auth/authVuex.js